namespace TabAurous.Master {
    export interface DesignationRow {
        DesignationId?: number;
        DesignationName?: string;
        Level?: string;
        LeaveDays?: number;
        AdvanceAmount?: number;
        Narration?: string;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
    }

    export namespace DesignationRow {
        export const idProperty = 'DesignationId';
        export const nameProperty = 'DesignationName';
        export const localTextPrefix = 'Master.Designation';
        export const lookupKey = 'Master.Designation';

        export function getLookup(): Q.Lookup<DesignationRow> {
            return Q.getLookup<DesignationRow>('Master.Designation');
        }
        export const deletePermission = 'HR:Designation:Delete';
        export const insertPermission = 'HR:Designation:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:Designation:Edit';

        export declare const enum Fields {
            DesignationId = "DesignationId",
            DesignationName = "DesignationName",
            Level = "Level",
            LeaveDays = "LeaveDays",
            AdvanceAmount = "AdvanceAmount",
            Narration = "Narration",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2"
        }
    }
}
